import { useMemo } from "react";

// Atmospheric drifting stars / dust for the hero background.
// Pure CSS animation (not framer-motion per-node) — 40 continuously
// looping elements were previously driven by JS on every frame, which
// showed up as real jank once combined with Lenis scroll + Metrika webvisor.
export const StarField = ({ count = 40 }) => {
  const stars = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => ({
        id: i,
        top: Math.random() * 100,
        left: Math.random() * 100,
        size: Math.random() * 2.4 + 1,
        delay: Math.random() * 5,
        duration: Math.random() * 4 + 3,
      })),
    [count]
  );

  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
      {stars.map((s) => (
        <span
          key={s.id}
          className="absolute rounded-full bg-[#F0C674] star-pulse"
          style={{
            top: `${s.top}%`,
            left: `${s.left}%`,
            width: s.size,
            height: s.size,
            boxShadow: "0 0 6px rgba(240,198,116,0.8)",
            animationDuration: `${s.duration}s`,
            animationDelay: `${s.delay}s`,
          }}
        />
      ))}
    </div>
  );
};
